import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class MarcadorService {
    async getAll() {
        return await api.get<any[]>(`${resources.marcador}/GetAll`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.marcador}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async atribuir(data: { marcadorID: number; clienteInstalacaoIDs: number[] }) {
        return await api.post<any>(`${resources.marcador}/Atribuir`, data);
    }

    // Cada instalação tem no máximo 1 marcador: a remoção não precisa informar qual.
    async remover(data: { clienteInstalacaoIDs: number[] }) {
        return await api.put<any>(`${resources.marcador}/Remover`, data);
    }
}

export default new MarcadorService();
